import React, { FC } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import FhirLoader from '../../../components/FhirLoader'
import Alert from 'react-bootstrap/Alert'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'

type EnterMfaFormProps = {
  formHandler: any;
  alertState: { show: boolean; variant: string; message: string; };
  closeAlert: () => void;
  isLoading: boolean;
}

const EnterMfaForm: FC<EnterMfaFormProps> = ({ formHandler, alertState, closeAlert, isLoading }) => {

  return (
    <>
      <h2 className='headerText h3'>Log In</h2>
      <Form noValidate onSubmit={formHandler.handleSubmit} id='login'>
        {
          alertState.show && (
            <Alert variant={alertState.variant} dismissible onClose={closeAlert}>
              {alertState.message}
            </Alert>
          )
        }
        <Form.Group className='custom'>
          <Form.Label>
            Validation Code:
          </Form.Label>
          <Form.Control
            type='text'
            placeholder='Enter Validation Code'
            name='mfaCode'
            value={formHandler.values.mfaCode}
            onChange={formHandler.handleChange}
            onBlur={formHandler.handleBlur}
            isInvalid={!!formHandler.errors.mfaCode && formHandler.touched.mfaCode}
            id='mfaCode'
          />
          {
            !!formHandler.errors.mfaCode && formHandler.touched.mfaCode && (
              <Form.Text className='text-danger'>
                {formHandler.errors.mfaCode}
              </Form.Text>
            )
          }
        </Form.Group>
        <div>
          {!isLoading ? (
            <div>
              <Row>
                <Col>
                  <Button type='submit' variant='primary'>Validate</Button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col>
                  <p className='small m-0'>
                    Missing or expired code? <Link to='/'>Start Over</Link>
                  </p>
                  <p className='small m-0'>Need Assistance? Contact Member Services under &quot;Help&quot;.</p>
                </Col>
              </Row>
            </div>
          ) : (
            <Button type='submit' variant='primary' disabled={isLoading}>
              <FhirLoader small={true} />
            </Button>
          )}
        </div>
      </Form>
    </>
  )
}

export default EnterMfaForm